import React, {
  createContext,
  ReactNode,
  useContext,
  useRef,
  useState,
} from "react";
import UtilityHelper from "../../service/utilities/UtilityHelper";
import DivisionsProvider from "./DivisionsProvider";
import { SearchDivisionList } from "../../model/divisions/DivisionsModel";
import StorageKeys from "../../const/StorageKeys";
import {
  addModal,
  ModalInterface,
  removeModal,
} from "../../libraries/state_reducers/widget/ModalsReducer";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import { useSelector } from "react-redux";
import { RootState } from "../../libraries/state_reducers/store";
import { useDispatch } from "react-redux";
import ModalKeys from "../../const/ModalKeys";
import SessionStorage from "../../service/storage/SessionStorage";
import { routeName as routeNameSearch } from "../../screens/search/SearchScreen";
import AppTranslation from "../../service/app_translation/AppTranslation";
import { setDivisionDetail } from "../../libraries/state_reducers/divisions/DivisionsReducer";

type DivisionsContextType = {
  divisionList: Array<SearchDivisionList> | null;
  getDivisionList: () => void;
  onClickDivision: (detail: SearchDivisionList) => void;

  showSearch: boolean;
  searchValue: string;
  handleOnChange: (name: string, value: string) => void;
  clearSearch: () => void;
  updateShowSearch: () => void;

  //divisionIdCurrent: string;
};

const DivisionsContext = createContext<DivisionsContextType | undefined>(
  undefined
);

export const DivisionsContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const type: number = ResponsiveDeviceType();
  const dispatch = useDispatch();

  const modals = useSelector((state: RootState) => state.modals.list);

  /* const companyGroupType: string =
    AppConfigService.get("company_group_type") ?? "0"; */

  /* const divisionIdCurrent: string =
    SessionStorage.getValue(StorageKeys.division_id) || "0"; */

  const searchValueRef = useRef<string>("");
  const divisionListResultRef = useRef<Array<SearchDivisionList> | []>([]);

  const [showSearch, setShowSearch] = useState<boolean>(type === 3);
  const [searchValue, setSearchValue] = useState<string>("");

  const [divisionList, setDivisionList] =
    useState<Array<SearchDivisionList> | null>(null);

  const onClickDivision = async (division: SearchDivisionList) => {
    SessionStorage.saveValue(StorageKeys.division_id, division.division_id!);
    SessionStorage.saveValue(StorageKeys.division_title, division.title!);

    dispatch(removeModal(ModalKeys.list_choose_division));
    closeModalLogic();

    const currentSlugName = UtilityHelper.getFullPathName();
    console.log("division onclick screen-name", currentSlugName);

    if (currentSlugName === routeNameSearch) {
      dispatch(setDivisionDetail(division));
    } else {
      dispatch(
        addModal({
          id: ModalKeys.list_choose_branch,
          title: AppTranslation.text("choose_preferred_branch"),
          screenMobileView: type !== 3,
          static: false,
        })
      );
    }
  };

  const getDivisionList = async () => {
    const searchDivisionListResult =
      await DivisionsProvider.getDivisionListAPI();
    if (searchDivisionListResult != null) {
      setDivisionList(searchDivisionListResult);
      divisionListResultRef.current = searchDivisionListResult;
    }
  };

  const handleOnChange = (fieldName: string, fieldValue: string) => {
    fieldName = fieldName.toLowerCase();
    if (fieldName === `search-division`) {
      setSearchValue(fieldValue);
      searchValueRef.current = fieldValue;

      const filtered: Array<SearchDivisionList> | undefined =
        divisionListResultRef.current?.filter((division) =>
          Object.values(division)
            .join(" ")
            .toLowerCase()
            .includes(searchValueRef.current.toLowerCase())
        );

      setDivisionList(filtered!);
    }
  };

  const clearSearch = () => {
    if (UtilityHelper.isEmpty(searchValueRef.current)) {
      updateShowSearch();
    }
    setDivisionList(divisionListResultRef.current);
    setSearchValue("");
    searchValueRef.current = "";
  };

  const updateShowSearch = () => {
    setShowSearch(!showSearch);
  };

  const closeModalLogic = async () => {
    const lastModal: ModalInterface = modals[modals.length - 1];
    if ((lastModal.screenMobileView ?? false) === true && type !== 3) {
      window.history.replaceState(null, "", window.location.pathname);
    }
  };

  return (
    <DivisionsContext.Provider
      value={{
        divisionList,
        getDivisionList,
        onClickDivision,

        showSearch,
        searchValue,
        handleOnChange,
        clearSearch,
        updateShowSearch,

        // divisionIdCurrent,
      }}
    >
      {children}
    </DivisionsContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const DivisionsContextImport = () => {
  const context = useContext(DivisionsContext);
  if (!context) {
    throw new Error(
      "DivisionsContextImport must be used within a DivisionsContextProvider"
    );
  }
  return context;
};
